import { render, staticRenderFns } from "./FaqSnapshots.vue?vue&type=template&id=dd7e3544&scoped=true&"
import script from "./FaqSnapshots.vue?vue&type=script&lang=js&"
export * from "./FaqSnapshots.vue?vue&type=script&lang=js&"
import style0 from "./FaqSnapshots.vue?vue&type=style&index=0&id=dd7e3544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7e3544",
  null
  
)

export default component.exports